import { nok } from "@/lib/format";

/** «4,85 MNOK» · «112 kkr» · «350 kr» – for KPIs and chart labels. Tables keep exact `nok()`. */
export function compactKr(v, { signed = false } = {}) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "–";
  const n = Number(v);
  const a = Math.abs(n);
  const sign = n < 0 ? "−" : signed && n > 0 ? "+" : "";
  if (a >= 1e6) return `${sign}${(a / 1e6).toFixed(a >= 1e8 ? 0 : a >= 1e7 ? 1 : 2).replace(".", ",")} MNOK`;
  if (a >= 1e4) return `${sign}${Math.round(a / 1e3)} kkr`;
  return `${sign}${nok(a)}`;
}

export const kr = (v) => nok(v);

export const pctOf = (part, whole) => (whole ? Math.round((Number(part) / Number(whole)) * 100) : 0);

export const daysBetween = (a, b) => Math.round((new Date(b) - new Date(a)) / 86400000);

export const INVOICE_STEPS = ["utkast", "sendt", "betalt"];
export const CONTRACT_STEPS = ["utkast", "signert", "aktiv", "avsluttet"];

/** Which primary actions make sense for an invoice in a given state. */
export function invoiceActions(inv, { canWrite, canApprove }) {
  const s = inv?.status;
  const a = [];
  if (!inv) return a;
  if (s === "utkast" && canWrite) a.push(inv.needs_approval && !canApprove ? "request_approval" : "send");
  if (s === "til_godkjenning" && canApprove) a.push("approve", "reject");
  if (s === "godkjent" && canWrite) a.push("send");
  if (["sendt", "forfalt", "delvis_betalt"].includes(s) && canWrite && inv.kind === "faktura") a.push("pay");
  if (s === "forfalt" && canWrite && (inv.reminder_level || 0) < 3) a.push("remind");
  if (["sendt", "forfalt", "delvis_betalt", "betalt"].includes(s) && canWrite && inv.kind === "faktura") a.push("credit");
  if (["utkast", "til_godkjenning", "godkjent"].includes(s) && canWrite) a.push("cancel");
  return a;
}
